import styled from 'styled-components';

export const Container = styled.div`
  background: var(--primary);
  width: 100%;
  height: 100%;
`;
